// @flow
interface Environment {
  version: string;
  baseApiUrl: string;
  environment: string;
  segmentIoToken: string;
  googleKey: string;
  sentryDSN: string;
  instagramUploadProductsClientId: string;
  stonlyWID: string;
  gaMeasurementId: string;
  customerIoKey: string;
  amplitudeKey: string;
  facebookPixelId: string;
  userGuidingKey: string;
  t3mUrl: string;
  dnsRecordValue: string;
  stripePricingTables: {
    [key: string]: {
      tableId: string,
      publishableKey: string,
    },
  };
  metaAppId: string;
  whatsappApiConfigId: string;
  instagramLoginConfigId: string;
}

const env: Environment = {
  version: process.env.VERSION || '',
  baseApiUrl: process.env.REACT_APP_ENDPOINT || '/api',
  environment: 'local',
  segmentIoToken: '',
  googleKey: 'AIzaSyAjmBjIugR57p_aWMyGUFJaj1Sh3le3aLE',
  sentryDSN: '',
  instagramUploadProductsClientId: '820016326976767',
  stonlyWID: '688932c5-cb07-11ec-9fb8-0ae9fa2a18a2',
  gaMeasurementId: 'G-R8BDD652HB',
  customerIoKey: 'd2a2193417ef21b24e7e',
  amplitudeKey: 'c054795371417edd5c6ea1b50634a46d',
  facebookPixelId: '1580919395621224',
  userGuidingKey: '232776016ID-TEST',
  t3mUrl:
    'https://cdn.jsdelivr.net/gh/TiendaDA/3-musketeers@0.0.13/packages/3-musketeers-js/dist/all.js',
  dnsRecordValue: '35.175.161.138',
  stripePricingTables: {
    default: {
      tableId: 'prctbl_1PGpeuIRDZjSGHgoFquETElC',
      publishableKey:
        'pk_test_51JjPiwIRDZjSGHgoWVgQ0mXc4QBbJgESD5didF5G74WTIgBhTG5jOsR4RwvhJhkkZMsAB3qcq5BEHEKeI7rP3ysd00TXrwWSWL',
    },
    ai_plans: {
      tableId: 'prctbl_1SnKpZIRDZjSGHgoiLIjjddD',
      publishableKey:
        'pk_test_51JjPiwIRDZjSGHgoWVgQ0mXc4QBbJgESD5didF5G74WTIgBhTG5jOsR4RwvhJhkkZMsAB3qcq5BEHEKeI7rP3ysd00TXrwWSWL',
    },
  },
  metaAppId: '626175946686308',
  whatsappApiConfigId: '654195997285889',
  instagramLoginConfigId: '2463794533957126',
};

if (
  process.env.REACT_APP_ENV === 'development' ||
  process.env.REACT_APP_ENV === 'staging'
) {
  env.environment = process.env.REACT_APP_ENV;
  env.sentryDSN =
    'https://b8fae0f8edfdbe1dc12bf06471739618@o4510751431262208.ingest.us.sentry.io/4510751529762816';
  env.segmentIoToken = '6oEjRhmADAUhi8KBgKxa4n64mPEzvwGU';
  env.instagramUploadProductsClientId = '820016326976767';
  env.stonlyWID = '72f9f01c-b9e3-11ec-9fb8-0ae9fa2a18a2';

  env.gaMeasurementId = 'G-R8BDD652HB';
  env.facebookPixelId = '1580919395621224';
  env.amplitudeKey = '098fa6baa8a02afa1a070f114ca920ad';
  env.customerIoKey = 'ae3435d35c8459e73c64';
  env.userGuidingKey = '232776016ID';

  env.stripePricingTables = {
    default: {
      tableId: 'prctbl_1PSnevIRDZjSGHgoLQH1tdHZ',
      publishableKey:
        'pk_test_51JjPiwIRDZjSGHgoWVgQ0mXc4QBbJgESD5didF5G74WTIgBhTG5jOsR4RwvhJhkkZMsAB3qcq5BEHEKeI7rP3ysd00TXrwWSWL',
    },
  };

  env.t3mUrl =
    'https://cdn.jsdelivr.net/gh/TiendaDA/3-musketeers@feature/amplituted-sdk/packages/3-musketeers-js/dist/all.js';

  env.metaAppId = '626175946686308';
  env.whatsappApiConfigId = '654195997285889';
  env.instagramLoginConfigId = '2463794533957126';
}

if (process.env.REACT_APP_ENV === 'staging') {
  env.dnsRecordValue = '50.19.242.240';
}

if (process.env.REACT_APP_ENV === 'production') {
  env.environment = 'production';
  env.sentryDSN =
    'https://b8fae0f8edfdbe1dc12bf06471739618@o4510751431262208.ingest.us.sentry.io/4510751529762816';
  env.segmentIoToken = 'pFe8UDYRFE3jClsyczMvyUOLcSrhf7Co';
  env.googleKey = 'AIzaSyCleGRl5hFzmJlDDW23OtXZ5wCH-ZdpgqI';
  env.instagramUploadProductsClientId = '1200006818352650';
  env.stonlyWID = '72f9f01c-b9e3-11ec-9fb8-0ae9fa2a18a2';
  env.gaMeasurementId = 'G-JFK264HFS8';

  env.gaMeasurementId = 'G-JFK264HFS8';
  env.facebookPixelId = '269230781455345';
  env.amplitudeKey = 'd3c6ee81f4e74130734cb34841950bf8';
  env.userGuidingKey = '232776016ID';
  env.customerIoKey = '61110d86070c9b1b8a37';

  env.t3mUrl =
    'https://cdn.jsdelivr.net/gh/TiendaDA/3-musketeers@0.0.13/packages/3-musketeers-js/dist/all.js';

  env.dnsRecordValue = '44.209.228.211';

  env.stripePricingTables = {
    default: {
      tableId: 'prctbl_1PSo06IRDZjSGHgoNPDq8Qg2',
      publishableKey:
        'pk_live_51JjPiwIRDZjSGHgoMuuBngbMQfLndGzMkRh0mPqfVb1ACG5ZD23UoaUPVPCYbVxTE8IZbvj6754fch0EN3uxCOA100itQL4pi6',
    },
    ai_plans: {
      tableId: 'prctbl_1T0PSRIRDZjSGHgoQ7nkSBAt',
      publishableKey:
        'pk_live_51JjPiwIRDZjSGHgoMuuBngbMQfLndGzMkRh0mPqfVb1ACG5ZD23UoaUPVPCYbVxTE8IZbvj6754fch0EN3uxCOA100itQL4pi6',
    },
  };

  env.metaAppId = '556244643829641';
  env.whatsappApiConfigId = '9309456819117106';
  env.instagramLoginConfigId = '574797675325137';
}

console.log('env', env);

export default env;
